import { chartDataManagerPlugin } from "./chart-data-manager-plugin";

export const plugins = [chartDataManagerPlugin];
